import montanaUserSlice from '@core/libs/store/slices/User.slice.js';

import { userDataApi } from '../server/userDataApi.js';
import montanaGuiSliceReducer from './slices/MontanaGui.slice.js';
import montanaIrrigationSlice from './slices/MontanaIrrigation.slice.js';
import montanaMaterialListSliceReducer from './slices/MontanaMaterialList.slice.js';

const montanaReducer = {
  gui: montanaGuiSliceReducer,
  irrigation: montanaIrrigationSlice,
  user: montanaUserSlice,
  [userDataApi.reducerPath]: userDataApi.reducer,
  materialList: montanaMaterialListSliceReducer,
};

export default montanaReducer;
